import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // 🚀 페이지 전환 커스텀 이벤트 발생 (GlobalTimerContext에서 감지)
    window.dispatchEvent(new CustomEvent('routeChange', {
      detail: { pathname }
    }));
  }, [pathname]);

  return null;
}
